import EmergencyRetrivalRequest from "../../components/EmergencyRetrivalRequest";

const EmergencyRetrivalRequestPage = () => {
  return <EmergencyRetrivalRequest />;
};
export default EmergencyRetrivalRequestPage;
